import { getAxiosClient } from "../../axios-client";
import { WarehouseDeletePayload } from "./types";


const axiosClient = getAxiosClient();
export const deleteWarehouse = async (body: WarehouseDeletePayload) => {
  return await axiosClient.ax.delete(
    "/Warehouses/Delete",
     { data: body }
  );
};